var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-col-12"},[_c('div',{staticClass:"card"},[_c('page-header',{attrs:{"title":"dataTable.reports.protocol-control.title","actions":_vm.pageActions}}),_c('ancestryline-data-table',{ref:"protocolcontrolreportdatatable",attrs:{"data-function":_vm.dataFunction,"columns":_vm.columns,"default-filter":_vm.filters}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }